import { Tooltip } from 'antd'
import { TemplateNameIndicator } from './TemplateNameIndicator'

export function TemplateNameLabel({ templateName, estimatedAccuracy, link }) {
  if (templateName) {
    return (
      <Tooltip
        title={
          estimatedAccuracy ? `Estimated Accuracy: ${estimatedAccuracy}%` : ''
        }
        placement="topLeft"
      >
        <div style={{ display: 'flex', alignItems: 'center', margin: '3px 0' }}>
          <TemplateNameIndicator estimatedAccuracy={estimatedAccuracy} />
          {link != null ? (
            <a href={link} target="_blank" rel="noreferrer">
              {templateName}
            </a>
          ) : (
            <div>{templateName}</div>
          )}
        </div>
      </Tooltip>
    )
  }
  return null
}
